import { Button } from '@quadralize/ui'
import { DangerCircle, Restart } from '@solar-icons/react'
import { motion } from 'framer-motion'
import { useRouteError } from 'react-router-dom'
import { ErrorLayout } from '../components/error-layout'

const ERROR_BLOBS = [
  {
    id: 'blob-1',
    color: 'bg-error/15',
    size: 'w-48 h-48 md:w-80 md:h-80',
    top: '-5%',
    right: '-5%',
    delay: 0,
  },
  {
    id: 'blob-2',
    color: 'bg-primary/10',
    size: 'w-56 h-56 md:w-96 md:h-96',
    bottom: '-10%',
    left: '-5%',
    delay: 2,
  },
]

export function GenericErrorScreen() {
  const error = useRouteError()
  const errorMessage = error instanceof Error ? error.message : 'Ocorreu um erro inesperado'

  return (
    <>
      <ErrorLayout
        code="Erro"
        title="Algo deu errado"
        description="Encontramos um erro inesperado. Tente recarregar a página ou voltar para o início."
        icon={<DangerCircle />}
        errorCode="UNEXPECTED_ERROR"
        blobs={ERROR_BLOBS}
        actions={
          <Button
            onClick={() => window.location.reload()}
            size="lg"
            startIcon={<Restart className="h-5 w-5" />}
            className="w-full sm:w-56"
          >
            Tentar novamente
          </Button>
        }
      />

      {import.meta.env.DEV && (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1 }}
          className="fixed right-4 bottom-4 left-4 z-50 mx-auto w-full max-w-md rounded-xl border border-error/20 bg-bg-base/80 p-4 shadow-lg backdrop-blur md:right-8 md:bottom-8 md:left-auto md:mx-0"
        >
          <h3 className="mb-2 flex items-center gap-2 font-bold text-error text-xs uppercase tracking-wider">
            <span className="h-2 w-2 animate-pulse rounded-full bg-error" />
            Informações de erro (debug)
          </h3>
          <code className="break-all font-mono text-text-secondary text-xs">{errorMessage}</code>
        </motion.div>
      )}
    </>
  )
}
